import React, {useEffect} from 'react';
import { Box, Image, Text, Container, Button, Grid } from '@chakra-ui/react';
import { default as Sign } from '../Assets/SVGs/web.svg';
import { default as Event } from '../Assets/SVGs/day.svg';
import { default as Money } from '../Assets/SVGs/money.svg';
import { useDisclosure } from '@chakra-ui/hooks';
import Modal from '../Components/HostSignUp';


function Area1(){

    const { isOpen, onOpen, onClose } = useDisclosure();
    return(
        <div>
            <Box mt="30px" >
                <Text fontSize="1rem" fontWeight="600" lineHeight="1.7" color="#4f8df7">
                    GROW, EARN, AND LEARN YOUR WAY
                </Text>
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w={["100%", "100%", "100%", "60%"]}>
                    Do what you love and get paid for it!
                </Text>
                <Text fontWeight="600" my="auto" fontSize="20px" mt="20px" w={["100%", "100%", "100%", "60%"]}>
                    You’re an expert at your craft. Share it with people in your community and make money doing it!
                </Text>
                <Button mt="30px" bg="#6ea3ff" color="white" p={7} borderRadius="90px" _hover={{backgroundColor: "#4f8df7"}} onClick={onOpen}>
                    Become a host
                </Button>
                <Modal onClose={onClose} onOpen={onOpen} isOpen={isOpen}  />
            </Box>
        </div>
    )
}

function Area2(){
    return(
        <div>
            <Box mt="120px" >
    
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w={["100%", "100%", "100%", "60%"]}>
                    What are Hangouts?
                </Text>
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={10} my={5}>

                    <Box w="100%" >
                        {/* <video width="50%" style={ {height: "100%",  objectFit: "cover"}} autoPlay muted playsInline loop  >
                            <source src="https://do1pg20gb8r9m.cloudfront.net/demoWorks.mp4"  type="video/mp4" />
                        </video> */}
                        <Grid templateColumns="repeat(2, 1fr)" >
                            {/* <Image src="https://do1pg20gb8r9m.cloudfront.net/Group 55-min.png" w="100%" />
                            <Image src="https://do1pg20gb8r9m.cloudfront.net/Group 52-min.png" w="100%" /> */}
                             <Image src="https://do1pg20gb8r9m.cloudfront.net/mockups/Home.png" w="100%" />
                            <Image src="https://do1pg20gb8r9m.cloudfront.net/mockups/Hangout 1.png" w="100%" />
                        </Grid>
                    </Box>
                
                        <Text fontWeight="800" my="auto" fontSize="20px">
                            Hangouts are in-person or online activities hosted by local experts  who want to share their craft with the community. Share your expertise and get paid.
                        </Text>
                 
                </Grid>

            </Box>
        </div>
    )
}

function Area3(){
    return(
        <div>
            <Box mt="120px" >
    
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w={["100%", "100%", "100%", "60%"]} >
                    How do Hangouts work?
                </Text>
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(3, 1fr)"]} gap={10} my={5}>

                <Box w="100%" mt="50px">
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            1
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Create a free account
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Join others in sharing experinces, making meaningful connections and a sense of community.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            2
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Create a Hangout and start Hosting
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Share something that you can do with the people in your own community.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Text textAlign="center"  fontSize="2rem" fontWeight="800" color="#4f8df7" >
                            3
                        </Text>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Cash out instantly
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            After your hangout is wrapped up, cash out right away and start planning your next hangout!
                        </Text>
                    </Box>
                </Grid>

            </Box>
        </div>
    )
}


function Area4(){
    return(
        <div>
            <Box mt="120px" mb="120px">
    
                <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w="70%" >
                How do Hangouts work?
                </Text>
                <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(3, 1fr)"]} gap={10} my={5}>

                <Box w="100%" mt="50px">
                        <Box mb={7}>
                            <img src={Sign} style={{margin: "auto", width: "40%"}}  />
                        </Box>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Create a free account
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Join others in sharing experinces, making meaningful connections and a sense of community.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Box mb={7}>
                            <img src={Event} style={{margin: "auto", width: "40%"}}  />
                        </Box>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Create a Hangout and start Hosting
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            Share something that you can do with the people in your own community.
                        </Text>
                    </Box>
                    <Box w="100%" mt="50px" >
                        <Box mb={7}>
                            <img src={Money} style={{margin: "auto", width: "40%"}}  />
                        </Box>
                        <Text textAlign="center"  fontSize="1.5rem" fontWeight="800">
                            Cash out instantly
                        </Text>
                        <Text textAlign="center"  mt="10px" >
                            After your hangout is wrapped up, cash out right away and start planning your next hangout!
                        </Text>
                    </Box>
                </Grid>

                <Text fontSize={["2rem", "2rem", "2rem", "1.5rem"]}  w="full"  textAlign="center" mt="60px" fontWeight="800"  >
                    We make money, if you make money. We take a service fee for transactions on our platform between Hosts and Participants—the rest is yours to keep! No hidden fees or extra charges.
                </Text>

            </Box>
        </div>
    )
}


// function Area1(){
//     return(
//         <div>
//             <Box mt="30px" >
//                 <Text fontSize="1rem" fontWeight="600" lineHeight="1.7">
//                     GROW, EARN, AND LEARN YOUR WAY
//                 </Text>
//                 <Text fontSize={["2rem", "2rem", "2rem", "3.125rem"]} mt="20px" fontWeight="800" w="60%">
//                     Do what you love and get paid for it!
//                 </Text>
//                 <Text fontWeight="600" my="auto" fontSize="20px" mt="20px" w="60%">
//                     You’re an expert at your craft. Share it with people in your community and make money doing it!
//                 </Text>
//             </Box>
//         </div>
//     )
// }




export default function Hosts(){
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return(
        <div>
        
            <Image 
            w="full"
            h="500px"
            objectFit="cover"
            src="https://do1pg20gb8r9m.cloudfront.net/hostsMain-min.jpg" />

            <Container maxW={["90%", "90%", "90%", "80%"]} mb={10} pt={8}  p={[0, 0, 0, 4]}>
                <Area1/>
                <Area2/>
                {/* <Area3/> */}
                <Area4/>
            </Container>


        </div>

    )
}